import { makeAutoObservable, runInAction } from 'mobx'
import { Post } from '../models/Post'
import agent from '../api/agent'
import { store } from './store'

export default class PostListStore {
  postRegistry = new Map<string, Post>()

  originalPosts: Post[] = []

  postDetails: Post | undefined = undefined

  constructor() {
    makeAutoObservable(this)
  }

  get posts() {
    return Array.from(this.postRegistry.values())
  }

  refreshPostRegistry = (posts: Post[]) => {
    this.postRegistry = new Map<string, Post>()
    posts.forEach((post) => {
      this.postRegistry.set(post.id, post)
    })
  }

  loadPosts = async () => {
    const { status, data: posts } = await agent.Posts.list()
    if (status === 200) {
      this.originalPosts = posts
      this.refreshPostRegistry(posts)
    }
  }

  
  loadPostsForHomePage = async () => {
    const { status, data: posts } = await agent.Posts.listForHomePage()
    if (status === 200) {
      this.originalPosts = posts
      this.refreshPostRegistry(posts)
    }
  }

  private async updatePostDetailsWithCurrency(post: Post, selectedCurrency: string) {
    const convertPrice = post.price
    const selectedCurrencyCode = store.methodsStore.currencyCodes[post.currency || 0]
    const currency = await store.exchangeCurrencyStore.fetchCurrency(
      selectedCurrencyCode,
      selectedCurrency,
      convertPrice,
    )

    runInAction(() => {
      this.postDetails = {
        ...post,
        convertedPrice: currency,
      }
    })
  }

  postBySlug = async (slug: string) => {
    const { status, data: post } = await agent.Posts.details(slug)
    if (status === 200) {
      await this.updatePostDetailsWithCurrency(post, store.methodsStore.selectedCurrency)
    }
  }

  updateSelectedCurrency = async (currency: string) => {
    store.methodsStore.selectedCurrency = currency
    if (this.postDetails) {
      await this.updatePostDetailsWithCurrency(this.postDetails, currency)
    }
  }
}
